import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IDepartment } from 'app/shared/model';

@Injectable({
  providedIn: 'root',
})
export class DepartmentApiService {
  protected resourceUrl = 'hrm-portal-api/api/departments/';

  constructor(public http: HttpClient) {}

  getDepartments(queryType?: any): Observable<any> {
    return this.http.get<IDepartment>(`${this.resourceUrl}`, { params: {queryType: queryType || ""} });
  }
}
